import { getApp } from 'firebase/app';
import { getPerformance } from 'firebase/performance';
import { environment } from '@lib/environments/environment';

/**
 * Initializes Firebase Performance Monitoring using the modular SDK.
 * This must be called early in the app initialization to ensure the performance
 * module is available on the Firebase app instance before the compat layer tries to use it.
 */
export function initializeFirebasePerformance(): void {
  if (environment.useEmulators) return;
  try {
    const app = getApp();
    getPerformance(app);
  } catch (error) {
    console.warn('Failed to initialize Firebase Performance Monitoring:', error);
  }
}
